<template>
  <ModalDialog
    ref="dialog"
    title="Edit Price Request"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-money-check-edit-alt"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Schedule">
        <FormOption label="Now" name="scheduleType" setting="now" v-model="scheduleType" inline="true" />
        <FormOption label="Scheduled" name="scheduleType" setting="schedule" v-model="scheduleType" inline="true" />
      </FormRow>
      <FormRow label="Scheduled Date" v-if="scheduleType == 'schedule'">
        <FormDate field="scheduleStartDate" v-model="priceRequestData.scheduleStartDate" />
      </FormRow>
      <FormRow label="Auto Generate Price Lists" v-if="priceRequestData.type == PriceRequestTypes.sales">
        <FormCheckbox field="isAutoGeneratePriceListsEnabled" v-model="priceRequestData.isAutoGeneratePriceListsEnabled" note="If set, will auto generate new price lists for any affected customers. Only required if emailing new price lists" />
      </FormRow>
      <FormRow label="Snapshot Archived Price Lists" v-if="priceRequestData.type == PriceRequestTypes.sales || priceRequestData.type == PriceRequestTypes.customer">
        <FormCheckbox field="isSnapshotArchivedPriceListsEnabled" v-model="priceRequestData.isSnapshotArchivedPriceListsEnabled" note="If set, will generate a PDF snapshot when archiving active price lists for any affected customers. If not set, old price lists will not be viewable" />
      </FormRow>
      <FormRow label="Price Request Reason">
        <FormInputTextArea placeholder="Reason for the price request" v-model="priceRequestData.reason" field="reason" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { PriceRequestTypes } from '@/store/types'

export default {
  name: 'PriceRequestEditDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    priceRequestId: Number
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      scheduleType: '',
      priceRequestData: {}
    }
  },
  created() {
    this.PriceRequestTypes = PriceRequestTypes
  },
  mounted() {
    
  },
  computed: {
    
  },
  methods: {
    show(priceRequestData) {
      // Reset form
      this.dialogForm = { }
      this.priceRequestData = _.cloneDeep(priceRequestData)

      this.scheduleType = this.priceRequestData.isScheduled ? 'schedule' : 'now'

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      let updateData = {
        isScheduled: this.scheduleType == 'schedule',
        scheduleStartDate: this.scheduleType == 'schedule' ? this.priceRequestData.scheduleStartDate : null,
        isAutoGeneratePriceListsEnabled: this.priceRequestData.isAutoGeneratePriceListsEnabled,
        isSnapshotArchivedPriceListsEnabled: this.priceRequestData.isSnapshotArchivedPriceListsEnabled,
        reason: this.priceRequestData.reason
      }

      this.$apiService.pricingService.updatePriceRequest(this.priceRequestId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    }
  }
}
</script>